/**
 * removes the "auth0|" prefix from the id
 */
export function removeAuth0Prefix(id: string) {
  return (id || '').includes('auth0|') ? id.split('auth0|')[1] : id
}
